module.exports = __webpack_public_path__ + "img/particle_motion_00079.700d2d3c.png";